module.exports = __webpack_public_path__ + "static/yuuki-9979c76d4b0da465570b79a9315209dd.png";